import React, { useEffect, useState } from "react";
import Kz from "../../components/spravochniki/kz/Kz";
import Modal from "../../components/UI/Modal";

function Page(props) {
  const [openingModal, setOpeningModal] = useState(false);

  useEffect(() => {
    setOpeningModal(true);
  }, []);
  
  return (
    <>
      <Modal
        fullwidth={"45%"}
        isOpen={openingModal}
        onClose={() => setOpeningModal(false)}
      >
        <Kz onClose={() => setOpeningModal(false)} />
      </Modal>
    </>
  );
}

export default Page;